<div
  [ngClass]="$safeNavigationMigration(severity()?.toLowerCase())"
  class="event-severity-display-container"
  [matTooltip]="tooltip() | translate"
  matTooltipClass="regular-tooltip"
  matTooltipPosition="right"
  [matTooltipDisabled]="!tooltip()"
>
  {{ 'IOT_DICTIONARY.' + $safeNavigationMigration(severity()?.toLowerCase()) | translate }}
</div>
